module.exports = __webpack_public_path__ + "static/img/JDJU3.0da7d032.png";